import { render, staticRenderFns } from "./foldButton.vue?vue&type=template&id=7efefc62&scoped=true&"
import script from "./foldButton.vue?vue&type=script&lang=js&"
export * from "./foldButton.vue?vue&type=script&lang=js&"
import style0 from "./foldButton.vue?vue&type=style&index=0&id=7efefc62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efefc62",
  null
  
)

export default component.exports